import { useRecoilValue } from 'recoil';
import { getPQDisplayText, PQLinkedValue } from 'common/util/pqUtil';
import { Column } from 'common/graphqlTypes';
import Link from 'components/common/Link/Link';
import { timezoneState } from 'components/common/Managers/PreferencesManager.state';

type PQCellProps = {
  cell: PQLinkedValue;
  header: Column;
};

/**
 * Table Cell component for PQ dashboard widgets.
 *
 * @prop cell     The cell object in the form of a PQLinkedValue
 * @prop header   Associated header configuration object for the column where this value is found.
 */
function PowerQueryCell({ cell, header }: PQCellProps): JSX.Element {
  const timezone = useRecoilValue(timezoneState);
  const displayValue = getPQDisplayText(cell, header, { timezone });

  if (displayValue === 'null' || !displayValue) {
    return <span className="PowerQueries__NullValue">—</span>;
  }

  if (cell.url) {
    return <Link href={cell.url}>{displayValue}</Link>;
  }

  return <>{displayValue}</>;
}

export default PowerQueryCell;
